<template>
<div>
		<div  class="firm_order m0 pr">
			<div class="firm_order_main pa">
				<span class="f18">页面错误！！</span>
				<p>{{errorMessage}}</p>
			</div>
		</div>
		<ft/>
</div>
</template>
<style>
  .firm_order{width:1200px;height: 500px;}
  .firm_order_main{top: 50%;margin: -50px 0 0 0;line-height:50px;left:25%;}
  .firm_order .firm_order_main span,.firm_order .firm_order_main p{width: 100%;display:inline-block;text-align: center;
  color:#5d5d5d;}
  .firm_order .firm_order_main p a{color:#1b3f75;background:url('/static/images/skipicon.png') no-repeat left center;padding-left:40px;
}
</style>

<script>

import ft from "./Footer" ;
export default {
	data(){
        return{
					errorMessage:'',
				}
	},
	methods: {
	 
	},
	mounted () {
			this.errorMessage = this.$route.params.errorMessage;
	},
	components:{
        ft,
	},
}
</script>



// WEBPACK FOOTER //
// ERROR.vue?3fec480d